import*as r from"react";import{jsx as n}from"react/jsx-runtime";var o=r.createContext(void 0);function c(t){let e=r.useContext(o);return t||e||"ltr"}export{c as a};
